import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Configuração padrão moderna para todas as notificações
const defaultConfig = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  style: {
    fontFamily: "'Mulish', sans-serif",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    fontSize: "14px",
    fontWeight: "500",
  },
};

class Message {
  sucess = (message) => {
    toast.success(message, {
      ...defaultConfig,
      className: "toast-success-custom",
    });
  };

  // Alias para corrigir o typo comum
  success = (message) => {
    this.sucess(message);
  };

  error = (message) => {
    toast.error(message, {
      ...defaultConfig,
      autoClose: 6000, // Erro fica mais tempo visível
      className: "toast-error-custom",
    });
  };

  warning = (message) => {
    toast.warning(message, {
      ...defaultConfig,
      className: "toast-warning-custom",
    });
  };

  info = (message) => {
    toast.info(message, {
      ...defaultConfig,
      className: "toast-info-custom",
    });
  };

  // Método adicional para mensagens de loading
  loading = (message) => {
    return toast.loading(message, {
      ...defaultConfig,
      autoClose: false,
      closeButton: false,
      className: "toast-loading-custom",
    });
  };

  // Método para atualizar um toast de loading
  update = (toastId, { type, message }) => {
    toast.update(toastId, {
      render: message,
      type: type,
      isLoading: false,
      autoClose: 4000,
      closeButton: true,
    });
  };
}

const message = new Message();
export default message;
